/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_owyLI8nXP",
    "aws_user_pools_web_client_id": "3fvarnllhmod5cm3aq845mlsfe",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://5fngyrnv32.execute-api.eu-west-1.amazonaws.com/dev}",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ahl44ij3kndnbauno7suswh7iu.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": ""
};

export default awsmobile;
